import { render } from "./DeleteProyectoGPT.vue?vue&type=template&id=5b90e4d4"
import script from "./DeleteProyectoGPT.vue?vue&type=script&lang=js"
export * from "./DeleteProyectoGPT.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__